export default "__VITE_ASSET__CtI_QowU__"